import moment from 'moment-timezone';

export const dateUtils = {
  formatForDisplay: (date: string | null | undefined, timezone: string) => {
    if (!date) return '';
    return moment.tz(date, timezone || 'UTC').format('YYYY-MM-DD HH:mm');
  },
  toUTC: (date: string | null | undefined, timezone: string) => {
    if (!date) return '';
    return moment
      .tz(date, timezone || 'UTC')
      .utc()
      .toISOString();
  },
  fromUTC: (date: string | null | undefined, timezone: string) => {
    return date ? moment.tz(date, timezone || 'UTC') : '';
  },
};
